export const photoList = [
  {
    url: require("../../assets/images/leaders/画板 1.jpg"),
    description:
      "中国工程院院士： 北京大学第一医院、《中国病案》杂志编委会名誉主任",
    name: "郭应禄教授"
  },
  {
    url: require("../../assets/images/leaders/画板 2.jpg"),
    description:
      "中国工程院院士：首都医科大学附属 北京儿童医院名誉院长、《中国病案》 杂志编委会名誉主任",
    name: "胡亚美教授"
  },
  {
    url: require("../../assets/images/leaders/画板 3.jpg"),
    description:
      "中国工程院院士：首都医科大学附属 北京朝阳医院名誉院长、《中国病案》 杂志编委会名誉主任",
    name: "翁心植教授"
  },
  {
    url: require("../../assets/images/leaders/画板 4.jpg"),
    description:
      "中国工程院院士：首都医科大学附属北京儿童医院外科主任、《中国病案》杂志编委会名誉主任",
    name: "张金哲教授"
  },
  {
    url: require("../../assets/images/leaders/画板 5.jpg"),
    description:
      "中国工程院院士：中国医学科学院 中国协和医科大学北京协和医院 妇产科主任 《中国病案》杂志编委会名誉主任",
    name: "郎景和教授"
  },
  {
    url: require("../../assets/images/leaders/画板 6.jpg"),
    description:
      "中国工程院院士：中国工程院党组成员、 副院长，中国医学科学院院长 国家呼吸临床研究中心主任 《中国病案》杂志编委会名誉",
    name: "主任王辰教授"
  }
];

export const imgList = [
  {
    url: require("../../assets/images/20/画板 1.jpg"),
    text:
      "中国工程院院士：北京大学第一医院、《中国病案》杂志编委会名誉主任郭应禄教授为《中国病案》杂志社题词",
    textWidth: "248",
    align: "left"
  },
  {
    url: require("../../assets/images/20/画板 2.jpg"),
    text:
      "中国工程院院士：北京大学第一医院、《中国病案》杂志编委会名誉主任 郭应禄教授为《中国病案》杂志社题词",
    textWidth: "248",
    align: "right",
    className: "reverse"
  },
  {
    url: require("../../assets/images/20/画板 3.jpg"),
    text:
      "中国工程院院士：首都医科大学附属北京朝阳医院名誉院长、《中国病案》杂志编委会名誉主任翁心植教授为《中国病案》杂志社题词",
    textWidth: "308",
    align: "left"
  },
  {
    url: require("../../assets/images/20/画板 4.jpg"),
    text:
      "中国工程院院士：首都医科大学附属北京儿童医院名誉院长、《中国病案》杂志编委会名誉主任胡亚美教授为《中国病案》杂志社题词",
    textWidth: "292",
    align: "right",
    className: "reverse"
  },
  {
    url: require("../../assets/images/20/画板 5.jpg"),
    text:
      "中国工程院院士：首都医科大学附属北京儿童医院外科主任、原《中国病案》杂志编委会名誉主任 张金哲教授为《中国病案》杂志社题词",
    textWidth: "323",
    align: "left"
  },
  {
    url: require("../../assets/images/20/画板 18.jpg"),
    text:
      "中国工程院院士：首都医科大学附属北京儿童医院外科主任、原《中国病案》杂志编委会名誉主任 张金哲教授为《中国病案》杂志社题词",
    textWidth: "630",
    align: "left",
    className: "cloum"
  },
  {
    url: require("../../assets/images/20/画板 6.jpg"),
    text:
      "中国工程院院士，中国医学科学院中国协和 医科大学北京协和医院妇产科主任 《中国病案》杂志编委会名誉主任郎景和教授",
    textWidth: "286",
    align: "right",
    className: "reverse"
  },
  {
    url: require("../../assets/images/20/画板 19.jpg"),
    text:
      "中国医院协会会长、《中国病案》杂志社名誉总编辑曹荣桂教授为《中国病案》杂志社题词 ",
    textWidth: "586",
    align: "left",
    className: "cloum"
  },
  {
    url: require("../../assets/images/20/画板 7.jpg"),
    text:
      "中国医院协会病案专业委员会主任委员 中国医院协会常务理事 《中国病案》杂志社社长胡燕生",
    textWidth: "249",
    align: "left"
  }
];

export const img2List = [
  {
    url: require("../../assets/images/20/画板 8.jpg"),
    text:
      "2000年5月《中国病案》杂志创刊号刊登的 原中华医院管理学会张自宽会长为《中国病案》杂志创刊发来的贺词",
    textWidth: "307",
    align: "right",
    className: "reverse"
  },
  {
    url: require("../../assets/images/20/画板 9.jpg"),
    text: "《中国病案》杂志社社长胡燕生贺辞",
    textWidth: "227",
    align: "left"
  },
  {
    url: require("../../assets/images/20/画板 10.jpg"),
    text: "《中国病案》杂志社编委会主任 总编辑刘爱民贺辞",
    textWidth: "198",
    align: "right",
    className: "reverse"
  },
  {
    url: require("../../assets/images/20/画板 11.jpg"),
    text: "《中国病案》杂志社副总编辑刘春玲贺辞",
    textWidth: "314",
    align: "left"
  },
  {
    url: require("../../assets/images/20/画板 12.jpg"),
    text: "《中国病案》杂志社副总编辑刘克新贺辞",
    textWidth: "257",
    align: "right",
    className: "reverse"
  },
  {
    url: require("../../assets/images/20/画板 13.jpg"),
    text: "《中国病案》杂志副总编辑马云波贺辞",
    textWidth: "329",
    align: "left"
  },
  {
    url: require("../../assets/images/20/画板 14.jpg"),
    text: "《中国病案》杂志社副总编辑梁金凤贺辞",
    textWidth: "257",
    align: "right",
    className: "reverse"
  },
  {
    url: require("../../assets/images/20/画板 15.jpg"),
    text: "《中国病案》杂志社副总编辑马娟贺辞",
    textWidth: "242",
    align: "left"
  },
  {
    url: require("../../assets/images/20/画板 16.jpg"),
    text: "《中国病案》杂志社副社长、副总编辑李卫红贺辞",
    textWidth: "316",
    align: "right",
    className: "reverse"
  },
  {
    url: require("../../assets/images/20/画板 17.jpg"),
    text: "《中国病案》杂志社副总编辑马家润贺辞",
    textWidth: "257",
    align: "left"
  }
];
